import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2'
import {GralMonService, PageBusquedaObject, GralMon, SatMon} from '../gral-mon.service';
import { LoginService } from '../../../login/login.service';

@Component({
  selector: 'app-formulario-gral-mon',
  templateUrl: './formulario-gral-mon.component.html',
  styleUrls: ['./formulario-gral-mon.component.css'],
  preserveWhitespaces: true
})

export class FormularioGralMonComponent implements OnInit {

  public id_param: number;
  public mon: GralMon = new GralMon();
  smon: SatMon[];
  errors: String[];
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  cargado: boolean;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public loginService: LoginService,
    private service: GralMonService
  ) { }

  ngOnInit() {
    this.cargado = true;
    this.mon.claveSat = new SatMon();

    this.busqueda.criteriaSearch = {};
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.service.getMoneda(this.id_param).subscribe(response => {
          this.mon = response.contenido;
          this.cerrarMensajeCarga();
        }, err => {
        this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  crear() {
    this.mon.gralUsrCreaId = this.loginService.usuario.id;
    this.mon.gral_emp_id = this.loginService.empresa as number;
    this.service.post(this.mon).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/gral-mon']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  actualizar() {
    this.mon.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.mon.gral_emp_id = this.loginService.empresa as number;
    this.service.put(this.mon).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/gral-mon']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  getSatMoneda() {
    this.service.getSatMoneda(this.mon.claveSat.clave.toLowerCase()).subscribe(response => {
      this.smon = response;

      if (this.smon != null && this.smon.length === 1) {
        this.mon.claveSat = this.smon[0];
        this.mon.descripcion = this.smon[0].descripcion;
        this.mon.no_dec = this.smon[0].decimales;
      }
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
